/* eslint-disable unicorn/filename-case */
// eslint-disable-next-line unicorn/filename-case
/* eslint-disable prefer-const */
/* eslint-disable prefer-destructuring */

import axios, { AxiosRequestConfig, AxiosResponse, Method } from "axios";

import { ApiService } from "./ApiService";
import Keys from "./Keys";

const encodeBase64DivID = (): string | null => {
  try {
    const base64DivID = btoa(Keys.DivisionID);
    return base64DivID;
  } catch (error) {
    console.log("encode error", error);
    return null;
  }
};

const authorizationTypes = {
  BASIC: "Basic",
  BEARER: "Bearer",
};

const getAuthenticatedHeader = (
  authorizationType: string,
  token: string | null
) => {
  let parseHeaders = {
    "Content-Type": "application/json",
    Authorization: "",
  };

  const base64DivID = encodeBase64DivID();

  if (authorizationType === authorizationTypes.BASIC && token === null) {
    if (base64DivID !== null) {
      parseHeaders = {
        ...parseHeaders,
        Authorization: `${authorizationType} ${base64DivID}`,
      };
    }
  } else if (authorizationType === authorizationTypes.BEARER) {
    parseHeaders = {
      ...parseHeaders,
      Authorization: `${authorizationType} ${token}`,
    };
  }

  return parseHeaders;
};

const getSignedRequestOptions = (
  method: Method,
  data: unknown,
  authorizationType: string,
  token: string | null
) => {
  const parseHeaders = getAuthenticatedHeader(authorizationType, token);

  const requestOptions: AxiosRequestConfig = {
    method,
    data,
    headers: parseHeaders,
  };

  return requestOptions;
};

const doFetch = async (url: string, requestOptions: AxiosRequestConfig) =>
  axios(url, requestOptions)
    .then((result) => result)
    .catch((error) => {
      let errorMessage =
        error.response && error.response.data
          ? error.response.data
          : error.message;
      errorMessage = errorMessage || JSON.stringify(error);

      console.log("Section Err Value");
      console.log(error);
      console.log(`Section Err Message: ${errorMessage}`);

      throw new Error(errorMessage);
    });
const getAuthorizationToken = <T = any>(
  url: string
): Promise<AxiosResponse<T>> => {
  const requestOptions = getSignedRequestOptions(
    "GET",
    null,
    authorizationTypes.BASIC,
    null
  );
  return doFetch(url, requestOptions);
};

const refreshToken = async () => {
  await getAuthorizationToken(ApiService.getToken).then((tokenResult) => {
    if (
      tokenResult.status === 200 &&
      tokenResult.data.errorMessage === "Success"
    ) {
      const currentTime: any = new Date();
      token = tokenResult.data.tokenData.token;
      let duration = tokenResult.data.tokenData.duration;
      expToken = new Date(currentTime.getTime() + duration * 60 * 1000);
    }
  });
};

let token = "";
let expToken: any;

// export const HttpService = {
//   getAuthorizationToken<T = any>(url: string): Promise<AxiosResponse<T>> {
//     const requestOptions = getSignedRequestOptions(
//       "GET",
//       null,
//       authorizationTypes.BASIC,
//       null
//     );
//     return doFetch(url, requestOptions);
//   },
//   async get<T = any>(url: string): Promise<AxiosResponse<T>> {
//     const currentTime: any = new Date();
//     if (token === "") {
//       await this.getAuthorizationToken(ApiService.getToken).then(
//         (tokenResult) => {
//           if (
//             tokenResult.status === 200 &&
//             tokenResult.data.errorMessage === "Success"
//           ) {
//             token = tokenResult.data.tokenData.token;
//             let duration = tokenResult.data.tokenData.duration;
//             expToken = new Date(currentTime.getTime() + duration * 60 * 1000);
//           } else {
//             console.log("API DOWN !!! CAN'T GET TOKEN :(");
//           }
//         }
//       );
//     }

//     const differenceInMinutes: any = (expToken - currentTime) / 1000 / 60;
//     if (differenceInMinutes < 10) {
//       await refreshToken();
//     }
//     const requestOptions = getSignedRequestOptions(
//       "GET",
//       null,
//       authorizationTypes.BEARER,
//       token
//     );
//     return doFetch(url, requestOptions);
//   },
//   async post<T = any>(url: string, data: unknown): Promise<AxiosResponse<T>> {
//     const currentTime: any = new Date();
//     if (token === "") {
//       await this.getAuthorizationToken(ApiService.getToken).then(
//         (tokenResult) => {
//           if (
//             tokenResult.status === 200 &&
//             tokenResult.data.errorMessage === "Success"
//           ) {
//             token = tokenResult.data.tokenData.token;
//             let duration = tokenResult.data.tokenData.duration;
//             expToken = new Date(currentTime.getTime() + duration * 60 * 1000);
//           } else {
//             console.log("API DOWN !!! CAN'T GET TOKEN :(");
//           }
//         }
//       );
//     }

//     const differenceInMinutes: any = (expToken - currentTime) / 1000 / 60;

//     if (differenceInMinutes < 10) {
//       await refreshToken();
//     }
//     const requestOptions = getSignedRequestOptions(
//       "POST",
//       data,
//       authorizationTypes.BEARER,
//       token
//     );
//     return doFetch(url, requestOptions);
//   },
// };

export const HttpService = {
  tokenPromise: null as Promise<AxiosResponse<any>> | null, // Variable to store the ongoing promise

  async getAuthorizationToken<T = any>(url: string): Promise<AxiosResponse<T>> {
    if (this.tokenPromise) {
      // Return the ongoing promise if a token request is already in progress
      return this.tokenPromise;
    }

    // Create and store a new promise if no request is in progress
    this.tokenPromise = (async () => {
      const requestOptions = getSignedRequestOptions(
        "GET",
        null,
        authorizationTypes.BASIC,
        null
      );
      const response = await doFetch(url, requestOptions);

      // Reset the promise once the request completes
      this.tokenPromise = null;

      // Handle token update here if needed
      return response;
    })();

    return this.tokenPromise;
  },

  async get<T = any>(url: string): Promise<AxiosResponse<T>> {
    const currentTime: any = new Date();
    if (token === "") {
      await this.getAuthorizationToken(ApiService.getToken).then(
        (tokenResult) => {
          if (
            tokenResult.status === 200 &&
            tokenResult.data.errorMessage === "Success"
          ) {
            token = tokenResult.data.tokenData.token;
            let duration = tokenResult.data.tokenData.duration;
            expToken = new Date(currentTime.getTime() + duration * 60 * 1000);
          } else {
            console.log("API DOWN !!! CAN'T GET TOKEN :(");
          }
        }
      );
    }

    const differenceInMinutes: any = (expToken - currentTime) / 1000 / 60;
    if (differenceInMinutes < 10) {
      await refreshToken();
    }
    const requestOptions = getSignedRequestOptions(
      "GET",
      null,
      authorizationTypes.BEARER,
      token
    );
    return doFetch(url, requestOptions);
  },

  async post<T = any>(url: string, data: unknown): Promise<AxiosResponse<T>> {
    const currentTime: any = new Date();
    if (token === "") {
      await this.getAuthorizationToken(ApiService.getToken).then(
        (tokenResult) => {
          if (
            tokenResult.status === 200 &&
            tokenResult.data.errorMessage === "Success"
          ) {
            token = tokenResult.data.tokenData.token;
            let duration = tokenResult.data.tokenData.duration;
            expToken = new Date(currentTime.getTime() + duration * 60 * 1000);
          } else {
            console.log("API DOWN !!! CAN'T GET TOKEN :(");
          }
        }
      );
    }

    const differenceInMinutes: any = (expToken - currentTime) / 1000 / 60;

    if (differenceInMinutes < 58) {
      await refreshToken();
    }
    const requestOptions = getSignedRequestOptions(
      "POST",
      data,
      authorizationTypes.BEARER,
      token
    );
    return doFetch(url, requestOptions);
  },
};
